var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.66684V10.0002M8.54168 4.5835H5.66669C4.26655 4.5835 3.56649 4.5835 3.03171 4.85599C2.5613 5.09567 2.17885 5.47812 1.93917 5.94853C1.66669 6.48331 1.66669 7.18337 1.66669 8.58351L1.66669 9.5835C1.66669 10.3601 1.66669 10.7484 1.79356 11.0546C1.96271 11.463 2.28717 11.7875 2.69555 11.9566C3.00183 12.0835 3.39012 12.0835 4.16669 12.0835V15.6252C4.16669 15.8186 4.16669 15.9154 4.17471 15.9969C4.25265 16.7882 4.8787 17.4142 5.66999 17.4921C5.75148 17.5002 5.84822 17.5002 6.04169 17.5002C6.23516 17.5002 6.3319 17.5002 6.41338 17.4921C7.20468 17.4142 7.83073 16.7882 7.90866 15.9969C7.91669 15.9154 7.91669 15.8186 7.91669 15.6252V12.0835H8.54169C10.0137 12.0835 11.8144 12.8726 13.2036 13.6299C14.014 14.0717 14.4193 14.2926 14.6847 14.2601C14.9308 14.2299 15.1169 14.1194 15.2611 13.9178C15.4167 13.7003 15.4167 13.2652 15.4167 12.3949V4.27207C15.4167 3.40183 15.4167 2.96671 15.2611 2.74924C15.1169 2.54759 14.9308 2.43709 14.6847 2.40694C14.4193 2.37444 14.014 2.59534 13.2036 3.03713C11.8144 3.79443 10.0137 4.5835 8.54168 4.5835Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.a48c2fa1dd9ea67842813674f6dabe06.svg";
export { ForwardRef as ReactComponent };